// Layouts
import LayoutBlank from '@layouts/LayoutBlank';

// Pages
import PageUnsubscribe from '@pages/index/PageUnsubscribe';

export default {
    path: '/',
    component: LayoutBlank,
    children: [
        {
            path: 'unsubscribe/:message_id?/:customer_id?/:unsubscribe_token?',
            name: 'unsubscribe',
            component: PageUnsubscribe,
            meta: {
                title: 'Unsubscribe',
            }
        },
    ]
}